module.exports = __webpack_public_path__ + "img/monitor_64.c938a399.jpg";